import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const Game = ({ toggleTheme, currentTheme }) => {
  return (
    <>
      <div className="content-area">
        <Outlet />
      </div>
      <Navbar toggleTheme={toggleTheme} currentTheme={currentTheme} />
    </>
  );
};

export default Game;